import { Center, HStack, Heading, Spinner, Text, VStack } from "native-base";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import qs from "qs";
import moment from "moment";
import QRCode from "react-qr-code";
import styles from "./styles.module.css";
import colors from "../../constants/colors";
import { StateContext, StatusContext } from "../../contexts";
import API from "../../api";
import { capitalize } from "../../utils";
import NoTickets from "../../components/noTickets";

function TicketsPage() {
  const status = useContext(StatusContext);
  const state = useContext(StateContext);
  const [isLoading, setIsLoading] = useState(true);
  const [bookings, setBookings] = useState([]);

  const getTickets = useCallback(async () => {
    try {
      setIsLoading(true);
      const query = qs.stringify({
        filters: {
          user: state.user.id,
          confirmed: true,
          service: {
            tour: {
              itinerary: {
                type: "origin",
                isReturn: false,
                departureDate: {
                  $gte: moment().toISOString(),
                },
              },
            },
          },
        },
      });
      const {
        data: { data: _bookings },
      } = await API(state.jwt).get(`/bookings?${query}`);
      setBookings(_bookings);
    } catch (error) {
      status.updateErrorMessage(error);
    }
    setIsLoading(false);
  }, [state.jwt, state.user.id, status]);

  useEffect(() => {
    getTickets();
  }, [getTickets]);

  return (
    <VStack>
      <Helmet>
        <title>Boletos</title>
      </Helmet>
      <VStack padding={10}>
        {isLoading ? (
          <Center height={300}>
            <Spinner size="lg" color={colors.primary} />
          </Center>
        ) : bookings?.length ? (
          <>
            <Heading color={colors.secondary} fontSize="2xl">
              Boletos
            </Heading>
            <div className={styles.ticketContainer}>
              {bookings.map((booking) => {
                const origin = booking.service.tour.itinerary.find(
                  (location) =>
                    !location.isReturn && location.type === "origin",
                );
                return (
                  <button key={booking.id} className={styles.ticket}>
                    <VStack
                      width={350}
                      backgroundColor={colors.white}
                      paddingX={10}
                      paddingY={7}
                      space={5}
                      overflow="hidden">
                      <Heading fontSize="md">
                        {booking.service.tour.name}
                      </Heading>
                      <Text>
                        {booking.firstName} {booking.lastName}
                      </Text>
                      <HStack>
                        <VStack flex={1}>
                          <Heading fontSize="md">Fecha</Heading>
                          <Text>
                            {capitalize(
                              moment(origin.departureDate).format(
                                "dddd, DD [de] MMMM [de] Y",
                              ),
                            )}
                          </Text>
                        </VStack>
                        <VStack flex={1}>
                          <Heading fontSize="md">Hora</Heading>
                          <Text>
                            {capitalize(
                              moment(origin.departureDate).format("hh:mm A"),
                            )}
                          </Text>
                        </VStack>
                      </HStack>
                      <HStack>
                        <VStack flex={1}>
                          <Heading fontSize="md">Punto de abordaje</Heading>
                          <Text>{booking.location.name}</Text>
                        </VStack>
                        <VStack flex={1}>
                          <Heading fontSize="md">Asiento</Heading>
                          <Text>{booking.seat}</Text>
                        </VStack>
                      </HStack>
                      <HStack justifyContent="space-between">
                        {Array.from(new Array(10)).map((_, index) => (
                          <Text
                            key={String(index)}
                            color={colors.lightGray}
                            fontSize={30}>
                            .
                          </Text>
                        ))}
                      </HStack>
                      <Center>
                        <QRCode size={200} value={booking.sku}></QRCode>
                      </Center>
                      <Text
                        color={colors.lightGray}
                        textAlign="center"
                        fontSize="sm">
                        Su reserva es emitida por Ticket Bus Plus SA de CV a
                        petición de la transportista, esta última es la única
                        responsable del cumplimiento del itinerario de viaje
                        previamente acordado y de todas y cada una de las
                        obligaciones que deriven del servicio se transportación
                        y exime de toda responsabilidad a Ticket Bus Plus SA de
                        CV y a cualquiera de sus empresa filiales, asociadas y
                        controladoras
                      </Text>
                    </VStack>
                  </button>
                );
              })}
            </div>
          </>
        ) : (
          <NoTickets />
        )}
      </VStack>
    </VStack>
  );
}

export default TicketsPage;
